export const guestCheckoutKeys = {
  all: ["guest-checkout"] as const,
  action: (token?: string) =>
    [...guestCheckoutKeys.all, "action", token] as const,
  status: (orderId: string) =>
    [...guestCheckoutKeys.all, "status", orderId] as const,
};
